
	import Vue from "vue";
	import helpers from "../inc/helpers";
	import TaxLookup from "../data/TaxLookup";
	import { Moment } from "moment";
	import moment from "moment";

	declare var gcTaxCalculatorAppData: any;
	declare var Chart: any;

	interface ParcelReevaluationData {
		"PARCEL ID": string;
		"2022 Total Value": number;
		"2023 Total Value": number;
	}

	export default Vue.extend({
		name: "ReevaluationDetail",

		props: {
			parcelId: String,
		},

		data() {
			return {
				isLoading: true as boolean,
				taxLookup: null as null | TaxLookup,
				now: null as null | Moment,
				parcelData: null as null | ParcelReevaluationData,
				newMarketValue: null as null | number,
				currentMarketValue: null as null | number,
				multiplier: 350 as number,
				taxBreakdown: [
					{
						label: "Local Government",
						color: "#FFAE0B",
						percent: 0.3,
						note: "The Local Government portion of this increase will be mitigated by an offsetting reduction of outside millage levy collection pursuant to Resolutions passed by the following entities: Bainbridge Twp., Claridon Twp., Burton Vill., Newbury Twp., Russell Twp., Munson Twp., Hambden Twp., Burton Twp., City of Chardon, Troy Twp., Chester Twp., Parkman Twp., Middlefield Twp., Montville Twp., Auburn Township, Middlefield Vill., and Thompson Twp.",
					},
					{
						label: "Local School District",
						color: "#3000BE",
						percent: 0.45,
						note: "The Local School District portion of this increase will be mitigated by an offsetting reduction of outside millage levy collection pursuant to Resolutions passed by the following entities: West Geauga LSD",
					},
					{
						label: "Geauga County",
						color: "#BD0021",
						percent: 0.25,
						note: "The Geauga County portion of this increase will be mitigated by an offsetting reduction of outside millage levy collection pursuant to the Board of County Commissioner Resolution passed on October 31, 2023.",
					},
				],
			};
		},

		async mounted() {
			this.isLoading = true;

			var chartJs = document.createElement("script");
			chartJs.setAttribute("src", "https://cdn.jsdelivr.net/npm/chart.js");
			document.head.appendChild(chartJs);

			this.now = moment();
			this.parcelData = await this.fetchData(this.parcelId);

			if (!!this.parcelData) {
				this.newMarketValue = this.parcelData["2023 Total Value"];
				this.currentMarketValue = this.parcelData["2022 Total Value"];
			}

			this.isLoading = false;

			setTimeout(() => {
				this.setChart();
			}, 250);
		},

		methods: {
			async fetchData(parcelId: string): Promise<null | ParcelReevaluationData> {
				const endpoint = gcTaxCalculatorAppData.ajax_url + "?action=getMarketValueByYear&parcelId=" + parcelId;
				const response = await fetch(endpoint);
				const json = await response.json();

				if (!!json.data && !!json.data.length) {
					return json.data[0];
				}

				return null;
			},

			setChart() {
				const ctx = <HTMLCanvasElement>this.$refs.myChart;

				if (ctx) {
					new Chart(ctx, {
						type: "doughnut",
						data: {
							labels: this.taxBreakdown.map((item: any) => item.label),
							datasets: [
								{
									data: this.taxBreakdown.map((item: any) => (this.reevaluation ? this.reevaluation * item.percent : 0)),
									backgroundColor: this.taxBreakdown.map((item: any) => item.color),
									hoverOffset: 4,
								},
							],
						},
						options: {
							cutout: "45%",
							plugins: {
								tooltip: {
									callbacks: {
										label: function(context: any) {
											let label = context.dataset.label || "";

											if (label) {
												label += ": ";
											}

											if (context.parsed !== null) {
												label += helpers.formatCurrency(context.parsed);
											}

											return label;
										},
									},
								},
							},
						},
					});
				}
			},
		},

		computed: {
			thisYear(): null | string {
				return !!this.now ? this.now.format("YYYY") : null;
			},

			lastYear(): null | string {
				return !!this.now
					? moment(this.now)
							.subtract(1, "year")
							.format("YYYY")
					: null;
			},

			taxDiff(): null | number {
				if (!!this.newMarketValue && !!this.currentMarketValue) {
					return this.newMarketValue - this.currentMarketValue;
				}

				return null;
			},

			reevaluation(): null | number {
				if (!!this.taxDiff) {
					return (this.taxDiff / 100000) * this.multiplier;
				}

				return null;
			},
		},

		filters: {
			formatCurrency(val: string) {
				return helpers.formatCurrency(val);
			},
		},

		components: {},
	});
